export default __webpack_public_path__ + "static/transform-your-business-86cf934f34de4cc46ad8ca3b8e8110c0.svg";